import {
  AutopostulacionActions,
  AutopostulacionState,
  ES_BLUE_COLLAR,
  ES_BLUE_COLLAR_ERROR,
  ES_BLUE_COLLAR_SUCCESS,
  GET_SUSCRIPCION_AUTOPOSTULACION,
  GET_SUSCRIPCION_AUTOPOSTULACION_ERROR,
  GET_SUSCRIPCION_AUTOPOSTULACION_SUCCESS,
  initialState,
  PUT_SUSCRIPCION_AUTOPOSTULACION,
  PUT_SUSCRIPCION_AUTOPOSTULACION_ERROR,
  PUT_SUSCRIPCION_AUTOPOSTULACION_SUCCESS,
} from '../types/autopostulacion'

const reducers = (state: any = initialState, action: AutopostulacionActions): AutopostulacionState => {
  switch (action.type) {
    case ES_BLUE_COLLAR:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
      }
    case ES_BLUE_COLLAR_SUCCESS:
      return {
        ...state,
        autopostulacion: { ...state.autopostulacion, ...action.payload },
        loading: false,
        error: false,
        success: true,
      }
    case ES_BLUE_COLLAR_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      }
    case GET_SUSCRIPCION_AUTOPOSTULACION:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
      }
    case GET_SUSCRIPCION_AUTOPOSTULACION_SUCCESS:
      return {
        ...state,
        autopostulacion: { ...state.autopostulacion, ...action.payload },
        loading: false,
        error: false,
        success: true,
      }
    case GET_SUSCRIPCION_AUTOPOSTULACION_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      }
    case PUT_SUSCRIPCION_AUTOPOSTULACION:
      return {
        ...state,
        suscribirStatus: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case PUT_SUSCRIPCION_AUTOPOSTULACION_SUCCESS:
      return {
        ...state,
        autopostulacion: { ...state.autopostulacion, suscripto: !state.autopostulacion.suscripto },
        suscribirStatus: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case PUT_SUSCRIPCION_AUTOPOSTULACION_ERROR:
      return {
        ...state,
        suscribirStatus: {
          loading: false,
          error: true,
          success: false,
        },
      }
    default:
      return state
  }
}

export default reducers
